/**
 * Dawn's Add to cart button only ever shows the per-unit price - it never
 * multiplies by the quantity selector. This makes it do that, using the
 * variant's real price (data-unit-price, added in buy-buttons.liquid) so it
 * stays correct across variant changes too.
 */
(() => {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) return '0';

      number = (number / 100).toFixed(precision);

      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const cents_ = parts[1] ? decimal + parts[1] : '';

      return dollars + cents_;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function updatePriceForRoot(root) {
    const match = root.id.match(/^BuyButtonPrice-(.+)$/);
    if (!match) return;

    const quantityInput = document.getElementById(`Quantity-${match[1]}`);
    if (!quantityInput) return;

    const quantity = Math.max(1, parseInt(quantityInput.value, 10) || 1);
    const format = root.dataset.moneyFormat;

    root.querySelectorAll('[data-unit-price]').forEach((priceEl) => {
      const unitPrice = parseInt(priceEl.dataset.unitPrice, 10);
      if (Number.isNaN(unitPrice)) return;
      priceEl.textContent = formatMoney(unitPrice * quantity, format);
    });
  }

  function bind(root) {
    if (root.dataset.qtySyncBound) return;

    const match = root.id.match(/^BuyButtonPrice-(.+)$/);
    if (!match) return;

    const quantityInput = document.getElementById(`Quantity-${match[1]}`);
    if (!quantityInput) return;

    root.dataset.qtySyncBound = 'true';
    quantityInput.addEventListener('change', () => updatePriceForRoot(root));
    quantityInput.addEventListener('input', () => updatePriceForRoot(root));

    updatePriceForRoot(root);
  }

  function apply(scope = document) {
    scope.querySelectorAll('[id^="BuyButtonPrice-"]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply());
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', (event) => apply(event.target));

  // Re-sync (not re-bind - the quantity input itself isn't replaced) after
  // Dawn swaps in the new variant's price HTML.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const root = document.getElementById(`BuyButtonPrice-${data.sectionId}`);
      if (root) updatePriceForRoot(root);
    });
  }
})();
